import { render, staticRenderFns } from "./Correspondences.vue?vue&type=template&id=040efe94&"
import script from "./Correspondences.vue?vue&type=script&lang=js&"
export * from "./Correspondences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports